import { useEffect, useLayoutEffect, useRef } from 'react';

export const useNewItemDetector = <T>(
  items: T[],
  getKey: (item: T) => string,
) => {
  const seenKeys = useRef<Set<string>>(new Set());
  const newKeys = useRef<Set<string>>(new Set());

  useEffect(() => {
    const currentNew = new Set<string>();
    for (const item of items) {
      const key = getKey(item);
      if (!seenKeys.current.has(key)) {
        currentNew.add(key);
        seenKeys.current.add(key);
      }
    }
    newKeys.current = currentNew;
  }, [items, getKey]);

  useLayoutEffect(() => {
    newKeys.current = new Set();
  });

  const isNew = (key: string): boolean => newKeys.current.has(key);

  return { isNew };
};
